
import themes from "@/mixins/themes"
import jobDetails from "@/mixins/job/jobDetails"

export default {
    name: "JobPageBaseInfo",
    mixins: [jobDetails, themes],
    props: {
        job: {
            type: Object,
            required: true,
        },
    },
    computed: {
        jobTypeName() {
            switch (this.job.type_id) {
                case 1:
                    return "Ausbildung"
                case 2:
                    return "Praktikum"
                case 3:
                    return "Job"
                default:
                    console.warn("Error: unrecognizable job type")
                    return ""
            }
        },
        textGreyShade() {
            return this.oaTheme.backgroundSecondary.isTextDark
                ? "grey-6--text"
                : "grey-2--text"
        },
    },
}
